const isDamImage = (url) =>
  typeof url === 'string' ? url.includes('://certainteed.widen.net/') : false;
export default isDamImage;
